<app-loader *ngIf="loader"></app-loader>

<p-card [header]="isEditMode ? 'Update Assign Roles' : 'Create Assign Roles'">
  <form [formGroup]="assignRoleForm">
    <div class="field col-12 flex justify-content-between align-items-center">
      <div class="flex">
        <div>
          <p-button *ngIf="isEditMode" label="Update" severity="info" (click)="update(assignRoleForm.value)"
            icon="pi pi-arrow-circle-up" size="small"></p-button>
        </div>
    
        <div>
          <p-button *ngIf="!isEditMode" label="Save" (click)="save()" class="p-button-outlined ml-2" icon="pi pi-save"
            size="small"></p-button>
        </div>
    
        <!-- <div>
            <p-button label="Reset" (click)="reset()" class="p-button-outlined ml-2" icon="pi pi-replay" severity="info" size="small"></p-button>
          </div> -->
    
        <div>
          <p-button label="Cancel" (click)="cancel()" class="p-button-outlined ml-2" icon="pi pi-times" severity="danger"
            size="small"></p-button>
        </div>
      </div>
    
      <div>
        <label class="block label-required" style="font-weight: bold;">Required Field</label>
      </div>
    </div>


    <div class="grid mt-3">
      <div class="col">
        <div class="field text-left">
          <label for="Role" class="label-required display"> Roles </label> 
          <div>
            <p-dropdown formControlName="Role" (onChange)="selectRole($event)" [options]="roleList"
              optionLabel="roleName" placeholder="Select Role" class="w-full mb-3" [readonly]="isEditMode">
            </p-dropdown>
          </div>
          <small *ngIf="submitted && formControls.Role.errors" id="name-error" class="text-red-500 block mt-1">
            Required field.
          </small>
        </div>

        <div class="flex gap-10">
          <div class="field text-left">
            <label for="tags">Description</label>
            <input formControlName="Description" pInputText class="w-full"
              [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.Description.errors}" />
            <small *ngIf="submitted && formControls.Description.errors" id="name-error" class="text-red-500 block mt-1">
              Required field.
            </small>
          </div>
        </div>
      </div>
    </div>

    <p-treeTable #dt1 [value]="files" [(selection)]="selectedMenu" [scrollable]="true"
      [tableStyle]="{'min-width':'50rem'}" scrollHeight="630px" styleClass="p-datatable-striped" [paginator]="true"
      [rows]="10" [(selection)]="selectedMenu"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,15,20]"
      [globalFilterFields]="['menuid', 'title', 'submenu']">
      <ng-template pTemplate="header">
        <tr>
          <th>Menu</th>
          <th>Menu Id</th>
          <th>Sub Menu Id</th>
          <th>Sub Menu</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttRow]="rowNode">
          <td>
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
            {{ rowData.menu }}
          </td>
          <td>{{ rowData.menuid }}</td>
          <td>{{ rowData.submenuId }}</td>
          <td>{{ rowData.submenu }}</td>
        </tr>
      </ng-template>
    </p-treeTable>

  </form>
</p-card>

<p-toast></p-toast>